import React from "react";
import { SvgIcon } from "@material-ui/core";

const SrPagoCardIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path d="M29.531 35.075H23.6a6.9 6.9 0 01-6.6-7.161V13.996a1.033 1.033 0 01.989-1.072h12.689a1.033 1.033 0 01.988 1.073v18.761a2.232 2.232 0 01-2.135 2.317zm.289-17.128v-1.968a.639.639 0 00-.639-.639h-1.7a.505.505 0 00-.505.505v2.1a.534.534 0 00.534.533h1.774a.534.534 0 00.536-.529z" />
    <path d="M0 0h48v48H0z" fill="none" />
  </SvgIcon>
);
SrPagoCardIcon.displayName = "SrPagoCardIcon";
SrPagoCardIcon.muiName = "SrPagoCardIcon";

export default SrPagoCardIcon;
